import { DateType } from "./filter-types";

export const DateTypeToBackend: Record<DateType, string> = {
  [DateType.CREATE]: "Create",
  [DateType.CLOSE]: "Close",
};
